// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module--wrapper--6d124","notification":"layout-module--notification--be213","main":"layout-module--main--e4575"};